import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchDateWiseSectionAttendanceData = async (data: any, methods: any) => {
	if (methods === 'Branches') {
		const URL = `${API_URL}BranchWiseAttendanceForToday`;
		if (process.env.NODE_ENV === 'development') console.log('Branch API URL:', URL);
		const requestData = {
			fetchBranchWiseDataToken: data,
		};
		if (process.env.NODE_ENV === 'development') console.log('Branch Request params:', data);
		return makeApiCall(URL, requestData);
	} else if (methods === 'Head Office') {
		const URL = `${API_URL}SectionWiseAttendanceForToday`;
		if (process.env.NODE_ENV === 'development') console.log('Section API URL:', URL);
		const requestData = {
			fetchDateWiseSectionAttendanceToken: data,
		};
		if (process.env.NODE_ENV === 'development') console.log('Section Request params:', data);
		return makeApiCall(URL, requestData);
	}
};
